export const newsletterData = [
    {
        id: 1,
        title: "Mastering CRM Automation in 2024",
        category: "CRM",

        url: "https://cdn.jsdelivr.net/gh/lifeintelect/storeimage@main/Lifeintelect_newsletter/IPDay.pdf",
        date: "Jan 15, 2024",
        readTime: "8 min read",
        image: "https://images.unsplash.com/photo-1553877522-43269d4ea984?w=600",
        description: "Discover how AI-powered CRM automation can transform your sales process and boost productivity.",
        sections: [
            {
                type: "text",
                content: "CRM automation is revolutionizing how businesses manage customer relationships. In this comprehensive guide, we explore the latest trends and technologies shaping the future of customer relationship management.",
            },
            {
                type: "title",
                content: "Key Benefits of CRM Automation",
            },
            {
                type: "bullets",
                items: [
                    "Increased sales productivity by 40%",
                    "Reduced manual data entry by 75%",
                    "Improved customer response time by 60%",
                    "Enhanced lead scoring accuracy",
                ],
            },
            {
                type: "image",
                src: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=800",
                alt: "CRM Dashboard",
            },
            {
                type: "subtitle",
                content: "Implementation Strategy",
            },
            {
                type: "steps",
                items: [
                    "Assess your current CRM workflow",
                    "Identify automation opportunities",
                    "Choose the right automation tools",
                    "Train your team on new processes",
                    "Monitor and optimize performance",
                ],
            },
        ],
    },
    {
        id: 2,
        title: "HR Management Trends to Watch",
        category: "HR",
        date: "Jan 20, 2024",
        readTime: "6 min read",
        image: "https://images.unsplash.com/photo-1600880292203-757bb62b4baf?w=600",
        description: "Stay ahead with the latest HR management trends that are reshaping the workplace experience.",
        sections: [
            {
                type: "text",
                content: "The HR landscape is evolving rapidly with new technologies and changing workforce expectations. Let's explore the key trends that will define HR management in 2024.",
            },
            {
                type: "title",
                content: "Top HR Trends",
            },
            {
                type: "bullets",
                items: [
                    "AI-powered recruitment and screening",
                    "Employee wellness and mental health focus",
                    "Remote work optimization tools",
                    "Data-driven performance management",
                ],
            },
            {
                type: "image",
                src: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800",
                alt: "HR Team",
            },
            {
                type: "steps",
                items: [
                    "Evaluate current HR processes",
                    "Implement modern HR software",
                    "Create employee feedback loops",
                    "Measure and iterate on results",
                ],
            },
        ],
    },
    {
        id: 3,
        title: "Boosting Sales with Data Analytics",
        category: "Sales",
        date: "Feb 5, 2024",
        readTime: "7 min read",
        image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=600",
        description: "Learn how data analytics can supercharge your sales strategy and drive revenue growth.",
        sections: [
            {
                type: "text",
                content: "Data analytics is no longer optional for sales teams. It's essential for understanding customer behavior and optimizing sales strategies.",
            },
            {
                type: "title",
                content: "Analytics Benefits",
            },
            {
                type: "bullets",
                items: [
                    "Better customer segmentation",
                    "Predictive lead scoring",
                    "Real-time sales performance tracking",
                    "Improved forecasting accuracy",
                ],
            },
            {
                type: "subtitle",
                content: "Getting Started with Sales Analytics",
            },
            {
                type: "steps",
                items: [
                    "Define your key metrics and KPIs",
                    "Integrate data sources into one platform",
                    "Set up real-time dashboards",
                    "Train your team on data interpretation",
                ],
            },
        ],
    },
    {
        id: 4,
        title: "The Future of Field Service Management",
        category: "Field Service",
        date: "Feb 12, 2024",
        readTime: "5 min read",
        image: "https://images.unsplash.com/photo-1581091226825-a6a2a5aee158?w=600",
        description: "Explore how IoT and mobile technology are transforming field service operations.",
        sections: [
            {
                type: "text",
                content: "Field service management is undergoing a digital transformation. Mobile apps, IoT sensors, and AI are making field operations more efficient than ever.",
            },
            {
                type: "title",
                content: "Key Technologies",
            },
            {
                type: "bullets",
                items: [
                    "IoT-enabled predictive maintenance",
                    "Mobile workforce management apps",
                    "Real-time GPS tracking and routing",
                    "Digital work order management",
                ],
            },
            {
                type: "image",
                src: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?w=800",
                alt: "Field Service",
            },
            {
                type: "steps",
                items: [
                    "Assess current field operations",
                    "Choose the right mobile platform",
                    "Train field technicians",
                    "Monitor and optimize routes",
                ],
            },
        ],
    },
];